const footerSi = {
    "follow_us": "Spremljajte nas!",
    "all_rights_reserved": "2024 Code Kitchen Kft vse pravice pridržane",
    "terms_and_conditions": "Pogoji poslovanja",
    "privacy_policy": "Pravilnik o zasebnosti"
};

export default footerSi;
